export default function arraysIntersect(array1, array2) {
  // error checks
  if (!Array.isArray(array1) || !Array.isArray(array2)) {
    throw new Error(
      'intersect() expected two arrays to compare.'
    );
  }

  let arraysDoIntersect = false;
  array2.forEach(item => {
    if (array1.includes(item)) {
      arraysDoIntersect = true;
    }
  });

  return arraysDoIntersect;
}
